import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DashboardOrder } from '../../entities/dashboard';
import { Dashboard, Merchant, Order } from './operationsInterface';

interface OperationData {
  data: Merchant | DashboardOrder;
}

interface OperationState {
  data: OperationData | null;
  order?: Order;
  updateAvailable?: boolean;
}

const initialState: OperationState = {
  data: null,
  order: undefined,
  updateAvailable: false,
};

export const operationSlice = createSlice({
  name: 'operation',
  initialState,
  reducers: {
    saveOperationData: (state, action: PayloadAction<OperationData>) => {
      state.data = action.payload;
    },
    clearOperationData: (state) => {
      state.data = null;
    },
    saveOperationOrderData: (state, action: PayloadAction<Order>) => {
      state.order = action.payload;
    },
    clearOperationOrderData: (state) => {
      state.order = undefined;
    },
    updateOperationStatus: (state, action: PayloadAction<boolean>) => {
      state.updateAvailable = action.payload;
    },
  },
});

export const {
  saveOperationData,
  clearOperationData,
  saveOperationOrderData,
  clearOperationOrderData,
  updateOperationStatus,
} = operationSlice.actions;

export default operationSlice.reducer;

// interface CommercialOfferData {
//   commercial_offer: DashboardOrder | null;
// }

// const initialState: CommercialOfferData = {
//   commercial_offer: null,
// };

// const operations = createSlice({
//   name: "operations",
//   initialState,
//   reducers: {
//     setCommercialOffer: (state, action: PayloadAction<DashboardOrder | null>) => {
//       state.commercial_offer = action.payload;
//     },
//   },
// });

// export const { setCommercialOffer } = operations.actions;

// export default operations.reducer;
